import { gql } from '@apollo/client';
export const GET_CONVERSION_MONITORING_METRICS = gql(/* GraphQL */ `
  query GetConversionMonitoringMetrics(
    $merchantId: ID!
    $fromDate: String!
    $toDate: String!
    $refresh: Boolean
  ) {
    getConversionMonitoringMetrics(
      input: { merchantId: $merchantId, fromDate: $fromDate, toDate: $toDate, refresh: $refresh }
    ) {
      dateRange {
        fromDate
        toDate
      }
      chartUnit
      aggregateMethod
      labels
      data
      aggregate
    }
  }
`);

export const GET_VISITORS_RECOGNIZED = gql(/* GraphQL */ `
  query GetVisitorsRecognized(
    $merchantId: ID!
    $fromDate: String!
    $toDate: String!
    $refresh: Boolean
  ) {
    getVisitorsRecognized(
      input: { merchantId: $merchantId, fromDate: $fromDate, toDate: $toDate, refresh: $refresh }
    ) {
      dateRange {
        fromDate
        toDate
      }
      chartUnit
      aggregateMethod
      labels
      data
      aggregate
    }
  }
`);

export const GET_TOTAL_EVENTS_TRACKED = gql(/* GraphQL */ `
  query GetTotalEventsTracked(
    $merchantId: ID!
    $fromDate: String!
    $toDate: String!
    $refresh: Boolean
  ) {
    getTotalEventsTracked(
      input: { merchantId: $merchantId, fromDate: $fromDate, toDate: $toDate, refresh: $refresh }
    ) {
      dateRange {
        fromDate
        toDate
      }
      chartUnit
      aggregateMethod
      labels
      data
      aggregate
    }
  }
`);

export const GET_ANON_VISITORS_CAPTURED = gql(/* GraphQL */ `
  query GetAnonVisitorsCaptured(
    $merchantId: ID!
    $fromDate: String!
    $toDate: String!
    $refresh: Boolean
  ) {
    getAnonVisitorsCaptured(
      input: { merchantId: $merchantId, fromDate: $fromDate, toDate: $toDate, refresh: $refresh }
    ) {
      dateRange {
        fromDate
        toDate
      }
      chartUnit
      aggregateMethod
      labels
      data
      aggregate
    }
  }
`);

export const GET_SERVER_EVENT_LOGS = gql(/* GraphQL */ `
  query GetServerEventLogs(
    $merchantId: ID!
    $fromDate: String!
    $toDate: String!
    $refresh: Boolean
  ) {
    getServerEventLogs(
      input: { merchantId: $merchantId, fromDate: $fromDate, toDate: $toDate, refresh: $refresh }
    ) {
      dateRange {
        fromDate
        toDate
      }
      chartUnit
      aggregateMethod
      labels
      data
      aggregate
    }
  }
`);

export const GET_PROFILES_LIST = gql(/* GraphQL */ `
  query GetProfilesList(
    $merchantId: ID!
    $fromDate: String!
    $toDate: String!
    $refresh: Boolean
    $limit: Float
  ) {
    getProfilesList(
      input: {
        merchantId: $merchantId
        fromDate: $fromDate
        toDate: $toDate
        refresh: $refresh
        limit: $limit
      }
    ) {
      profiles {
        email
        firstName
        lastName
        lastSeen
        phone
        source
      }
      anonVisitorCount
    }
  }
`);

export const GET_PROFILES_METRICS = gql(/* GraphQL */ `
  query GetProfilesMetrics(
    $merchantId: ID!
    $fromDate: String!
    $toDate: String!
    $refresh: Boolean
  ) {
    getProfileMetrics(
      input: { merchantId: $merchantId, fromDate: $fromDate, toDate: $toDate, refresh: $refresh }
    ) {
      totalProfiles
      anonVisitorCount
    }
  }
`);

export const GET_METRICS_COMPARISON = gql`
  query GetMetricsComparison(
    $merchantId: ID!
    $fromDate: String!
    $toDate: String!
    $metricType: MetricComparisonType!
    $refresh: Boolean
  ) {
    getMetricsComparison(
      input: {
        merchantId: $merchantId
        fromDate: $fromDate
        toDate: $toDate
        metricType: $metricType
        refresh: $refresh
      }
    ) {
      currentPeriod {
        aggregate
        data
        labels
        chartUnit
        aggregateMethod
        dateRange {
          fromDate
          toDate
        }
      }
      previousPeriod {
        aggregate
        data
        labels
        chartUnit
        aggregateMethod
        dateRange {
          fromDate
          toDate
        }
      }
      percentageChange
      absoluteChange
    }
  }
`;

export const GET_LIFECYCLE_REVENUE = gql(/* GraphQL */ `
  query GetLifecycleRevenue(
    $merchantId: ID!
    $fromDate: String!
    $toDate: String!
    $refresh: Boolean
  ) {
    getLifecycleRevenue(
      input: { merchantId: $merchantId, fromDate: $fromDate, toDate: $toDate, refresh: $refresh }
    ) {
      dateRange {
        fromDate
        toDate
      }
      chartUnit
      aggregateMethod
      labels
      data
      aggregate
    }
  }
`);

export const GET_FLOWS_REVENUE = gql(/* GraphQL */ `
  query GetFlowsRevenue($merchantId: ID!, $fromDate: String!, $toDate: String!, $refresh: Boolean) {
    getFlowsRevenue(
      input: { merchantId: $merchantId, fromDate: $fromDate, toDate: $toDate, refresh: $refresh }
    ) {
      dateRange {
        fromDate
        toDate
      }
      chartUnit
      aggregateMethod
      labels
      data
      aggregate
    }
  }
`);

export const GET_LIFETIME_REVENUE = gql(/* GraphQL */ `
  query GetLifetimeRevenue($merchantId: ID!, $refresh: Boolean) {
    getLifetimeRevenue(merchantId: $merchantId, refresh: $refresh)
  }
`);

export const GET_LIFETIME_ROI = gql(/* GraphQL */ `
  query GetLifetimeROI($merchantId: ID!, $refresh: Boolean) {
    getLifetimeROI(merchantId: $merchantId, refresh: $refresh)
  }
`);

export const GET_EMQ_SCORES_BY_DATE_RANGE = gql(/* GraphQL */ `
  query GetEMQScoresByDateRange($startDate: String!, $endDate: String!) {
    getEMQScoresByDateRange(input: { startDate: $startDate, endDate: $endDate }) {
      date
      META_ADD_PAYMENT_INFO_EMQ_SCORE
      META_VIEW_CONTENT_EMQ_SCORE
      META_PAGE_VIEW_EMQ_SCORE
      META_INITIATE_CHECKOUT_EMQ_SCORE
      META_PURCHASE_EMQ_SCORE
      META_LEAD_EMQ_SCORE
      META_ADD_TO_CART_EMQ_SCORE
    }
  }
`);

export const GET_EM_SCORE_AVERAGE_AND_TREND = gql(/* GraphQL */ `
  query GetEMQScoreAverageAndTrend($startDate: String!, $endDate: String!) {
    getEMQScoreAverageAndTrend(input: { startDate: $startDate, endDate: $endDate }) {
      priorScore
      endScore
      avgScore
    }
  }
`);

export const GET_EMQ_SCORE_DEFAULT_AND_AVERAGE = gql(/* GraphQL */ `
  query GetEMQScoreDefaultAndAverage($startDate: String!, $endDate: String!) {
    getEMQScoreDefaultAndAverageForTimePeriod(input: { startDate: $startDate, endDate: $endDate }) {
      eventName
      priorScore
      currentAvg
    }
  }
`);
